// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"a5307324","223":"65919f42","680":"364e5ce7"}[chunkId] + ".chunk.js");